import React from "react"

import "./JungBlurVisualisation.scss"

const JungBlurVisualisation = () => <svg className="jung-blur-visualisation"></svg>

export default JungBlurVisualisation
